import {AbstractService} from 'services/AbstractService';

const PROJECT_UTM_GROUPS_LIST = '/api/projects/{0}/utmtagger/groups';

export class UTMService extends AbstractService {
  async groupsList (accountId, projectId) {
    return (await this.client.get(PROJECT_UTM_GROUPS_LIST.format(projectId), {}, {accountId})).items;
  }
}
